import { Edit } from 'react-admin';
import { MediaPlatformSettingsForm } from './MediaPlatformSettings.Form';
import { BackButton } from '../../../helperComponents/BackButton';
import { transformMediaPlatformSettings } from '../../../../utils/transformUtils';

export const MediaPlatformSettingsEdit = (props) => {
  return (
    <>
      <BackButton path="/media_platform_api_settings" />
      <span className="h4">Edit Conversions API Setting</span>
      <Edit {...props} title=" " redirect={false} transform={transformMediaPlatformSettings}>
        <MediaPlatformSettingsForm isEdit={true} />
      </Edit>
    </>
  );
};
